import { FormEvent, useState } from "react";
import { clientError } from "../lib/clientMessage";
import { supabase } from "../lib/supabase";

// Email + password only. There is deliberately no sign-up path: Release 1 has
// no self-serve tenant creation (ADR-13 deferred to Release 4), and membership
// is provisioned as a platform operation. In production the console also sits
// behind Cloudflare Access (ADR-26); this screen is the second gate, not the
// only one.

export function SignIn() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    // Respondents sign in here too, so the auth service's own text is never
    // shown (DISCLOSURE_POLICY, category 5): a wrong password in plain words,
    // anything else through clientError.
    if (error) {
      setError(
        error.code === "invalid_credentials"
          ? "That email and password do not match. Please try again."
          : clientError("signin", error).message,
      );
    }
    setBusy(false);
  }

  return (
    <div className="auth-page">
      <form className="card auth-card" onSubmit={submit}>
        <img className="logo" src="/brand/linnfoss-logo.svg" alt="LINNFOSS" />
        <h1 style={{ marginBottom: "0.25rem" }}>Assessments</h1>
        <p style={{ color: "var(--text-muted)", marginTop: 0 }}>
          Sign in to continue.
        </p>
        {error && <div className="error-banner">{error}</div>}
        <div className="field">
          <label htmlFor="email">Email</label>
          <input
            id="email"
            type="email"
            autoComplete="username"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div className="field">
          <label htmlFor="password">Password</label>
          <input
            id="password"
            type="password"
            autoComplete="current-password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <button className="btn" type="submit" disabled={busy} style={{ width: "100%" }}>
          {busy ? "Signing in…" : "Sign in"}
        </button>
        <p style={{ color: "var(--text-muted)", fontSize: "var(--lf-meta-size)", marginBottom: 0 }}>
          Accounts are provisioned by LINNFOSS. There is no self-service
          registration.
        </p>
      </form>
    </div>
  );
}
